/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Step_2Inputs */

const en_svc_n8n_step_2 = /** @type {(inputs: Svc_N8n_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the workflow with error handling, retries and alerts.`)
};

const lv_svc_n8n_step_2 = /** @type {(inputs: Svc_N8n_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidojam darba plūsmu ar kļūdu apstrādi, atkārtotiem mēģinājumiem un brīdinājumiem.`)
};

/**
* | output |
* | --- |
* | "Build the workflow with error handling, retries and alerts." |
*
* @param {Svc_N8n_Step_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_step_2 = /** @type {((inputs?: Svc_N8n_Step_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Step_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_step_2(inputs)
	return en_svc_n8n_step_2(inputs)
});